(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  if(document.querySelector('.klaviyo_form_trigger')){
    /* document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
    		window._klOnsite = window._klOnsite || []; 
    		window._klOnsite.push(['openForm', 'Yf5Z3W']);
    }); */


  }

  } catch(e) { console.error(e); }
})();
})();
